<template>
  <div class="doctorPage">
       <div class="doctor-content" v-if="doctor_list.length>0 && !isShow_Info">
              <ul>
                     <li v-for="(item, i) in doctor_list" :key="i" @click="doc_card_click(item)">
                            <Icon name="cross" @click.stop="del_doctor(item)" class="del-doctor"/>
                            <div class="doctor-img">
                                   <img :src="item.phead">
                            </div>
                            <div class="doctor-name">{{item.pname}}</div>
                     </li>
              </ul>
       </div>
       <!-- 创建医师弹窗 -->
       <Popup :show="showPicker_doctor" destroy-on-close position="center" :round='true' duration="0.1">
              <div class="create-doctor">
                     <div class="create-title">创建医师</div>
                     <div class="close-popup">
                            <Icon name="cross" @click="close_create_doctor" />
                     </div>
                     <div class="create-content">
                            <div class="doc-name">
                                   <Field class="field" placeholder="请输入医师姓名(仅支持中文)" v-model="doctor_info.name" maxlength="20" type="text"/>
                            </div>
                            <div class="doc-head">
                                   <Uploader max-count="1" v-model="doctor_info.head_img" multiple :preview-full-image='false' accept="image/*"/>
                            </div>
                            <div class="doc-info">
                                   <textarea ref="textareaRef"  id="autoResizeTextarea" rows="1"  maxlength="100"  v-model="doctor_info.synopsis" placeholder="请输入医师简介(长度100个字符)"></textarea>
                            </div>
                     </div>
                     <Button type="success" @click="submit_doctor" class="doctor-submit">提交</Button>
              </div>
       </Popup>
       <div class="add_doctor" @click="add_doctor" v-if="!isShow_Info">+</div>
       <!-- 医师详情页面 -->
       <DoctorInfo :doc_info='select_doctor' v-if="isShow_Info" :isShowInfo="isShow_Info"  @update-isShowInfo="handleMessageUpdate" />
  </div>
</template>
<script setup>
import { computed, getCurrentInstance, onMounted, ref, onBeforeMount, nextTick } from "vue";
import { Form, Field, CellGroup, Icon, Popup, Picker, Uploader, Button, showToast, showLoadingToast, closeToast, showSuccessToast } from 'vant';
import DoctorInfo from '@/components/video/doctorInfo.vue'
import { put_file, createDoctor, getAllDoctor, delDocter } from '@/api/index'
const showPicker_doctor = ref(false);
const upFile = ref('')
const doctor_info = ref({
  name: '',
  head_img: [],
  synopsis: ''
});
const select_doctor = ref() //选择的医师
const doctor_list = ref([])
// 1. 使用 Vue ref 来引用 textarea 元素
const textareaRef = ref(null);
const fileList = ref([]);
const isShow_Info = ref(false)

function autoResize() {
  // 5. 使用 nextTick 确保 DOM 已更新
  nextTick(() => {
    if (textareaRef.value) {
      // 2. 先将高度重置为自动，以便 scrollHeight 能反映内容的真实高度
      textareaRef.value.style.height = 'auto';
      // 3. 将高度设置为内容的滚动高度
      textareaRef.value.style.height = textareaRef.value.scrollHeight + 'px';
    }
  });
}

onMounted( async () => {
        showLoadingToast({
              message: "加载中...",
              duration: 0
       });

       let res = await getAllDoctor()
       doctor_list.value = res.data
       
       closeToast();
});
// 处理子组件返回值
const handleMessageUpdate = (newValue) => {
  isShow_Info.value = newValue;
}
// 医师卡片事件
const doc_card_click = (item) => {
       isShow_Info.value = true
       select_doctor.value = item
       console.log(item)
}
const add_doctor = () =>{
       showPicker_doctor.value = true
       setTimeout(()=>{
              if (textareaRef.value) {
                     textareaRef.value.addEventListener('input', autoResize);
                     autoResize();
              }
       },500)
}
// 提交
const submit_doctor = async () => {
       let arr = doctor_list.value
       // 中文验证
       console.log(doctor_info.value.name)
       const chineseRegex = /^[\u4e00-\u9fa5]+$/;
       if(!chineseRegex.test(doctor_info.value.name)){
              showToast('用户名只能出现中文')
              return
       }
       if(doctor_info.value.head_img.length == 0){
              showToast('请选择上传图片')
              return
       }
       if(doctor_info.value.synopsis == ''){
              showToast('请输入医师简介')
              return
       }
       
       showLoadingToast({
              message: "创建中...",
              duration: 0
       });
       const formData = new FormData();
       console.log(fileList.value[0])
       formData.append('files[]', doctor_info.value.head_img[0].file);
       // doctor_info.value.head_img = formData
       const response = await put_file(formData);

       let param = {
              pname:doctor_info.value.name,
              pinfo:doctor_info.value.synopsis,
              phead:response.data.MediaUrl
       }
       // 创建医师
       await createDoctor(param)
       // 获取创建之后的医师列表
       let res = await getAllDoctor()
       doctor_list.value = res.data

       // 重置输入框
       doctor_info.value = {
              name: '',
              head_img: [],
              synopsis: ''
       }
       showSuccessToast('成功')
       setTimeout(()=>{closeToast();},500)
}
// 关闭弹窗
const close_create_doctor = () =>{
       showPicker_doctor.value = false
       doctor_info.value = {
              name: '',
              head_img: [],
              synopsis: ''
       }
}
// 删除医师
const del_doctor = async (item) => {
        showLoadingToast({
              message: "删除中...",
              duration: 0
       });
       let is_del = confirm('是否确认删除医师,删除后将无法恢复')
       if(is_del){
              await delDocter({pid:item.pid})
              let res = await getAllDoctor()
              doctor_list.value = res.data
       }
       closeToast();
}
</script>
<style scoped>
       .doctorPage{
              height: 100%;
              width: 99%;
              margin: 0 auto;
              position: relative;
              overflow: auto;
       }
       .create-doctor{
              padding: 20px 20px 30px 20px;
       }
       .create-title{
              min-width: 300px;
              font-size: 25px;
              border-bottom: 1px solid #ddd;
              text-align: center;
              padding-bottom: 10px;
       }
       .add_doctor{
              font-size: 70px;
              background: rgba(22, 22, 245, 0.3);
              position: fixed;
              width: 70px;
              height: 70px;
              text-align: center;
              line-height: 70px;
              color: #fff;
              border-radius: 50%;
              bottom: 50px;
              right: 60px;
              box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1),-5px -5px 10px rgba(0, 0, 0, 0.1);
              cursor: pointer;
       }
       .create-content{
              font-size: 22px;
       }
       .create-content>div{
              margin-bottom: 15px;
       }
       .create-content input{
              border: 0;
              border-bottom: 1px !important;
       }
       .doc-name,.doc-head,.doc-info{
              display: flex;
              align-items: flex-start;
       }
       .doc-name,.doc-head{
              border-bottom: 1px solid #ddd;
       }
       #autoResizeTextarea {
              width: 100%;
              resize: none;
              overflow-y: hidden;
              padding: 10px;
              box-sizing: border-box;
              line-height: 1.5;
              min-height: 60px;
              transition: height 0.2s ease-out;
              font-size: 18px;
              border-radius: 15px;
       }
       .doctor-submit{
              width: 100%;
              font-size: 22px;
       }
       .close-popup{
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 10px !important;
              cursor: pointer;
       }
       .doctor-content ul{
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); /* 关键：自动创建列，设置最小和最大宽度 */
              justify-content: space-between; /* 关键：水平方向两端对齐，使行内项目顶到两侧 */
              gap: 15px; 
              padding: 20px;
              border-radius: 8px;
       }
       .doctor-content li{
              width: 130px;
              height: 150px;
              border: 1px rgba(22, 22, 245, 0.3) solid;
              box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
              border-radius: 15px;
              position: relative;
              text-align: center;
              padding-top: 17px;
              margin: 0 auto;
              margin-bottom: 42px;
              cursor: pointer;
       }
       .del-doctor{
              cursor: pointer;
              color: #ddd;
              font-size: 15px;
              position: absolute;
              right: 10px;
              top: 10px;
       }
       .doctor-img img{
              width: 80px;
              height: 80px;
              border-radius: 50%;
       }
       .doctor-name{
              margin-top: 10px;
              font-size: 15px;
       }
</style>